import { render, staticRenderFns } from "./InformeGlobal.vue?vue&type=template&id=73fea672"
import script from "./InformeGlobal.vue?vue&type=script&lang=js"
export * from "./InformeGlobal.vue?vue&type=script&lang=js"
import style0 from "./InformeGlobal.vue?vue&type=style&index=0&id=73fea672&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports